import produce from "immer";
import {
  FETCH_INPUT_DATA_SUCCESS,
  FETCH_INPUT_DATA,
  REFETCH_INPUT_DATA,
  START_FETCHING_MORE,
  NO_MORE_TO_FETCH,
  SELECT_ONE_SOURCE,
  SELECT_ONE_SOURCE_SUCCESS,
  GET_SOURCE_CSV_FILE_SUCCESS,
  SUBMIT_IMAGE_SUCCESS,
  FIT_IMAGE_SIZE,
  CLEAN_SELECTED_IMAGE,
  CHANGE_FILTER_BTN_STATUS,
  ROTATE_IMAGE,
  ROTATE_IMAGE_FINISH,
  MARK_BENCHMARK,
  MARK_BENCHMARK_FAILURE,
  MARK_BENCHMARK_SUCCESS,
  GET_NEXT_IMAGE_ID,
  RESET_STATE_IMAGES,
} from "./constants";
import {
  ADD_ISSUE_SUCCESS,
  DELETE_ISSUE_SUCCESS,
  RESOLVE_ISSUE_SUCCESS,
  REOPEN_ISSUE_SUCCESS,
} from "redux/issues/actions";
import {
  FETCH_INITIAL_DATA_SUCCESS,
  FETCH_INITIAL_DATA,
  CHANGE_CURRENT_DROPDOWN_STATUS,
} from "redux/app/constants";
import { getCookie } from "helpers";

function getImgFake(url) {
  let img = new Image();
  img.setAttribute("crossorigin", "anonymous");
  img.src = url;
  return img;
}

export const initialState = {
  imageId: "",
  imageUrl: "",
  originalUrl: "",
  imageIndex: null,
  isFetchingData: false,
  isBenchmarkProject: false,
  isBenchmark: false,
  status: "",
  metadata: {
    name: "",
    width: 0,
    height: 0,
    opacity: 1,
    brightness: 1,
    contrast: 1,
    size: 0,
  },
  limit: 10,
  allImgIds: [],
  allImages: {},
  paginationByStatus: { page: 0, more: true },
  paginationByStatusScrollUp: { page: 0, more: true },
  labelerName: "",
  labelerUserId: "",
  reviewerName: "",
  reviewerUserId: "",
  fitCounter: 0,
  filterBtnStatus: true,
  annotationType: "",
  largeImagePreprocessor: {
    preprocessorArr: [],
    zoomLevels: [0],
  },
  thumbnailURL: "",
  rotating: false,
  imageRotationDirection: 1,
  imgFake: null,
  loadingBenchmark: false,
  annotatedBy: "",
  qualityData: 0,
  scrollImage: false,
  nextImageId: "",
  filterTagIds: [],
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CHANGE_CURRENT_DROPDOWN_STATUS:
        draft.allImgIds = [];
        draft.allImages = {};
        draft.paginationByStatus = initialState.paginationByStatus;
        draft.paginationByStatusScrollUp =
          initialState.paginationByStatusScrollUp;
        draft.nextImageId = "";
        break;

      case GET_SOURCE_CSV_FILE_SUCCESS: {
        const { labelerName, reviewerName } = action.payload;
        draft.labelerName = labelerName || "";
        draft.reviewerName = reviewerName || "";
        break;
      }

      case REFETCH_INPUT_DATA:
        draft.isFetchingData = true;
        break;

      case FETCH_INPUT_DATA:
        draft.isFetchingData = true;
        break;

      case START_FETCHING_MORE:
        break;

      case RESET_STATE_IMAGES:
        draft.allImgIds = [];
        draft.allImages = {};
        draft.paginationByStatus = initialState.paginationByStatus;
        draft.paginationByStatusScrollUp =
          initialState.paginationByStatusScrollUp;
        draft.nextImageId = "";
        break;

      case FETCH_INITIAL_DATA:
        draft.isFetchingData = true;
        break;

      case FETCH_INPUT_DATA_SUCCESS: {
        const { images, page, isScrollDown } = action.payload;
        draft.isFetchingData = false;
        if (isScrollDown) {
          draft.paginationByStatus.page = page;
        } else {
          draft.paginationByStatusScrollUp.page = page;
        }
        const existingIds = new Set(draft.allImgIds);

        if (isScrollDown) {
          for (const image of images) {
            if (!image.sourceId) continue;

            const id = image.sourceId;
            draft.allImages[id] = image;

            if (!existingIds.has(id)) {
              draft.allImgIds.push(id);
            }
          }
        } else {
          const newIds = [];

          for (const image of images) {
            if (!image.sourceId) continue;

            const id = image.sourceId;
            draft.allImages[id] = image;

            if (!existingIds.has(id)) {
              newIds.unshift(id);
            }
          }

          draft.allImgIds.unshift(...newIds.reverse());
        }

        break;
      }

      case FETCH_INITIAL_DATA_SUCCESS: {
        const { images, page } = action.payload;

        draft.paginationByStatus.page = page;
        draft.paginationByStatusScrollUp.page = page - 2;
        draft.isFetchingData = false;

        if (typeof action.payload.isSelectOneSourceSuccess !== "undefined") {
          draft.isSelectOneSourceSuccess = true;
        } else {
          draft.isSelectOneSourceSuccess = false;
        }

        for (const image of images) {
          if (!image.sourceId) continue;
          const id = image.sourceId;

          draft.allImgIds.push(id);
          draft.allImages[id] = image;
        }
        break;
      }

      case NO_MORE_TO_FETCH: {
        const { isScrollDown } = action.payload;
        draft.isFetchingData = false;
        if (isScrollDown) {
          draft.paginationByStatus.more = false;
        } else {
          draft.paginationByStatusScrollUp.more = false;
        }
        break;
      }

      case SELECT_ONE_SOURCE:
        draft.imageUrl = "";
        draft.thumbnailURL = "";
        draft.largeImagePreprocessor = initialState.largeImagePreprocessor;
        draft.imageIndex = [...draft.allImgIds].findIndex(
          (item) => Number(item) === Number(action.payload.id)
        );
        break;
      case SELECT_ONE_SOURCE_SUCCESS: {
        const userInfoInCookie = JSON.parse(getCookie("userInfo"));
        const storage_config = JSON.parse(userInfoInCookie.storage_config);
        const imageId = action.payload.sourceId;
        if (storage_config.storage_type === "s3") {
          draft.thumbnailURL = action.payload.thumbnailVideo;
          draft.imageUrl = action.payload.url;
          draft.imgFake = getImgFake(action.payload.url);
        } else {
          draft.thumbnailURL = action.payload.thumbnailVideo;
          draft.imageUrl = action.payload.url;
          draft.imgFake = getImgFake(action.payload.url);
        }
        draft.annotationType = action.payload.dataType;
        draft.metadata.width = action.payload.metadata.width;
        draft.metadata.height = action.payload.metadata.height;
        draft.metadata.name = action.payload.name;
        draft.metadata.size = action.payload.metadata.size;
        draft.largeImagePreprocessor = action.payload.largeImagePreprocessor;
        draft.imageId = imageId;
        draft.status = action.payload.status;
        draft.metadata.opacity = action.payload.opacity;
        draft.metadata.brightness = action.payload.brightness;
        draft.metadata.contrast = action.payload.contrast;
        draft.originalUrl = action.payload.url;
        draft.isBenchmarkProject =
          action.payload.settingQuality === "benchmark";
        draft.isBenchmark = action.payload.isBenchmark;
        draft.annotatedBy = action.payload.annotatedBy;
        draft.qualityData = action.payload.qualityData;
        draft.labelerUserId = action.payload.labelerUserId;
        draft.reviewerUserId = action.payload.reviewerUserId;
        draft.tags = action.payload.tags;
        draft.imageRotationDirection =
          action.payload.metadata.imageRotationDirection || 1;
        break;
      }

      case CLEAN_SELECTED_IMAGE:
        draft.metadata.width = initialState.metadata.width;
        draft.metadata.height = initialState.metadata.height;
        draft.metadata.name = initialState.name;
        draft.metadata.size = initialState.metadata.size;
        draft.imageUrl = initialState.url;
        draft.thumbnailURL = "";
        draft.largeImagePreprocessor = initialState.largeImagePreprocessor;
        draft.imageId = initialState.sourceId;
        draft.status = initialState.status;
        draft.metadata.opacity = initialState.opacity;
        draft.metadata.brightness = initialState.brightness;
        draft.metadata.contrast = initialState.contrast;
        draft.originalUrl = initialState.oldUrl;
        draft.labelerName = "";
        draft.reviewerName = "";
        draft.annotationType = "";
        break;

      case ADD_ISSUE_SUCCESS: {
        const { sourceId } = action.payload;
        const currSource = state.allImages[sourceId];
        if (currSource) {
          const open =
            Number(
              (currSource && currSource.issue && currSource.issue.open) || 0
            ) + 1;
          const total =
            Number(
              (currSource && currSource.issue && currSource.issue.total) || 0
            ) + 1;

          draft.allImages[sourceId].issue = {
            status: open === 0 ? false : true,
            open,
            total,
          };
        }

        break;
      }

      case DELETE_ISSUE_SUCCESS:
        if (!action.payload.parentId) {
          const { sourceId } = action.payload;

          const currSource = state.allImages[sourceId];
          if (currSource) {
            const open = Math.max(Number(currSource.issue.open || 0) - 1, 0);
            const total = Math.max(Number(currSource.issue.total) - 1, 0);

            draft.allImages[sourceId].issue = {
              status: open === 0 ? false : true,
              open,
              total,
            };
          }
        }
        break;

      case RESOLVE_ISSUE_SUCCESS: {
        const { sourceId } = action.payload;
        const currSource = state.allImages[sourceId];
        if (currSource) {
          const open = Math.max(Number(currSource.issue.open || 0) - 1, 0);
          const total = currSource.issue.total;

          draft.allImages[sourceId].issue = {
            status: open === 0 ? false : true,
            open,
            total,
          };
        }
        break;
      }

      case REOPEN_ISSUE_SUCCESS: {
        const { sourceId } = action.payload;
        const currSource = state.allImages[sourceId];
        if (currSource) {
          const open = Math.max(Number(currSource.issue.open || 0) + 1, 0);
          const total = currSource.issue.total;

          draft.allImages[sourceId].issue = {
            status: open > 0 ? true : false,
            open,
            total,
          };
        }
        break;
      }

      case SUBMIT_IMAGE_SUCCESS: {
        const { sourceId, removeCurrentImage = false } = action.payload;

        if (removeCurrentImage) {
          const index = draft.allImgIds.indexOf(sourceId);
          if (index !== -1) {
            draft.allImgIds.splice(index, 1);
          }

          delete draft.allImages[sourceId];
        }
        break;
      }

      case FIT_IMAGE_SIZE:
        draft.fitCounter += 1;
        break;

      case CHANGE_FILTER_BTN_STATUS: {
        const { filterBtnStatus, filterTagIds } = action.payload;
        draft.filterBtnStatus = filterBtnStatus;
        if (filterTagIds) draft.filterTagIds = filterTagIds;
        break;
      }
      case ROTATE_IMAGE_FINISH: {
        const {
          id,
          status,
          width,
          height,
          src,
          thumbSrc,
          imageRotationDirection,
        } = action.payload;
        draft.rotating = false;
        if (status) {
          draft.imageUrl = src;
          draft.metadata.width = width;
          draft.metadata.height = height;
          draft.thumbnailURL = thumbSrc;
          draft.imgFake = getImgFake(src);
          if (draft.allImages[id]) draft.allImages[id].thumbnailUrl = thumbSrc;
          draft.imageRotationDirection = imageRotationDirection;
        }
        break;
      }

      case ROTATE_IMAGE:
        draft.rotating = true;
        break;

      case MARK_BENCHMARK: {
        draft.loadingBenchmark = true;
        break;
      }

      case MARK_BENCHMARK_FAILURE: {
        draft.loadingBenchmark = false;
        break;
      }

      case MARK_BENCHMARK_SUCCESS: {
        const { sourceId, email, isBenchmark } = action.payload;
        draft.isBenchmark = isBenchmark;
        draft.loadingBenchmark = false;
        draft.annotatedBy = email;
        draft.allImages[sourceId].isBenchmark = true;
        draft.allImages[sourceId].annotatedBy = email;
        break;
      }

      case GET_NEXT_IMAGE_ID:
        draft.nextImageId = action.payload;
        break;

      default:
    }
  });

export default reducer;
